import script from "./FilterChip.vue?vue&type=script&setup=true&lang=js"
export * from "./FilterChip.vue?vue&type=script&setup=true&lang=js"

import "./FilterChip.vue?vue&type=style&index=0&id=beace440&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-beace440"]])

export default __exports__